import BaseService from './baseService';
import { ProbeFilter } from 'store/probe/types';

export default class ProbesService extends BaseService {
    constructor() {
        super('probe');
    }

    /**
     * Gets list of probe groups
     * @param {Object} filter 
     * @param {number} filter.pageSize
     * @param {number} filter.pageNumber
     * @param {string} filter.searchString
     * @param {Array<number>} filter.taskIds
     * @returns list of probe group
     */
    getProbeGroups = (filter: ProbeFilter) => this.httpPostRequest('list', filter);

    /**
     * Gets list of probe group histories
     * @param {Object} filter 
     * @param {number} filter.pageSize
     * @param {number} filter.pageNumber
     * @param {string} filter.searchString
     * @param {Array<number>} filter.taskIds
     * @returns list of histories
     */
    getProbeGroupsHistory = (filter: ProbeFilter) => this.httpPostRequest('history', filter);

    /**
     * Gets list of probes history
     * @param filter 
     * @param {number} filter.pageSize
     * @param {number} filter.pageNumber
     * @param {string} filter.searchString
     * @param {Array<number>} filter.taskIds
     * @returns list of probes histories
     */
    getProbesHistory = (filter: ProbeFilter) => this.httpPostRequest('statuses', filter);

    /**
     * Gets list of probe scenario groups
     * @param {Object} filter 
     * @param {number} filter.pageSize
     * @param {number} filter.pageNumber
     * @param {string} filter.searchString
     * @param {Array<number>} filter.taskIds
     * @returns list of probe scenario group
     */
    getScenarioGroups = (filter: ProbeFilter) => this.httpPostRequest('scenarioGroups', filter);

    /**
     * Saves probe group
     * @param {Object} group - probe group item
     * @param {number} group.taskId - task id
     * @param {number} group.probeGroupId - probe group id
     * @param {string} group.fileName - file name
     * @param {string} group.description - group description
     * @returns void
     */
    saveProbeGroup = (group: {
        taskId: number;
        probeGroupId?: number;
        fileName?: string;
        description?: string;
    }) => this.httpPutRequest('', group);

    /**
     * Deletes probe groups
     * @param {Object} filter 
     * @param {Array<number>} filter.probeGroupIds - probe group ids
     * @returns void
     */
    deleteProbeGroups = (filter: { probeGroupIds: number[] }) => this.httpPostRequest('delete', filter);

    /**
     * Runs probes
     * @param {Object} request - run probes request
     * @param {string} request.targetScenarioGroupName
     * @param {string} request.suffix
     * @param {boolean} request.autoRunSOM
     * @param {boolean} request.createSOMInputs
     * @param {number} request.sourceScenarioGroupId
     * @param {number} request.probeGroupId
     * @returns void
     */
    runProbes = (request: {
        targetScenarioGroupName: string;
        suffix: string;
        autoRunSOM: boolean;
        createSOMInputs: boolean;
        sourceScenarioGroupId: number;
        probeGroupId: number;
    }) => this.httpPostRequest('run', request);

    /**
     * Gets url
     * @param {number} groupId 
     * @returns url for download
     */
    getProbesUrl = (groupId: number) => this.httpGetRequest(`downloadUrl/${groupId}`);

    /**
     * Upload probe file
     * @param {number} groupId 
     * @param {File} file 
     * @returns void
     */
    uploadProbeFile = (groupId: number, file: File) => {
        const formData = new FormData();
        formData.append('file', file);
        return this.httpPostRequest(`upload/${groupId}`, formData, { 'Content-Type': 'multipart/form-data' });
    };
}
